export default "__VITE_ASSET__8c79b8d0__"